import React from 'react';
import { ShieldIcon, LockIcon, AwardIcon, GlobeIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full min-h-screen flex items-center justify-center" style={{
    backgroundImage: 'linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.65)), url(https://cdn.magicpatterns.com/uploads/3rX7jYDrtspyb5yrWbxgmL/jose-vazquez-Q5RBHz9cu1A-unsplash.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed'
  }} aria-label="Hero section" data-id="element-38">
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-24" data-id="element-39">
        {/* Headline */}
        <h1 className="font-bold text-white text-3xl sm:text-4xl leading-tight tracking-tight" style={{
        fontSize: 'clamp(1.75rem, 4vw, 44px)',
        lineHeight: '1.15',
        textShadow: '0px 2px 12px rgba(0,0,0,0.6)'
      }} data-id="element-40">
          Precision Transcription &amp; Translation Services You Can Trust
        </h1>

        {/* Subheadline */}
        <p className="mt-5 text-lg leading-relaxed max-w-2xl mx-auto text-white" style={{
        textShadow: '0px 2px 12px rgba(0,0,0,0.6)'
      }} data-id="element-41">
          Transforming spoken words into written text and bridging language
          barriers with accuracy, confidentiality, and 15+ years of expertise.
        </p>

        {/* CTAs */}
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center items-stretch sm:items-center" data-id="element-42">
          <a href="#" className="w-full sm:w-auto min-h-[52px] flex items-center justify-center font-bold text-white rounded-lg px-10 py-3 text-base transition-opacity hover:opacity-90" style={{
          backgroundColor: '#2DA5A0'
        }} data-id="element-43">
            Get a Free Quote
          </a>
          <a href="#" className="w-full sm:w-auto min-h-[52px] flex items-center justify-center font-bold rounded-lg px-10 py-3 text-base transition-opacity hover:opacity-90" style={{
          backgroundColor: '#ffffff',
          color: '#1B2A4A'
        }} data-id="element-44">
            View Our Services
          </a>
        </div>

        {/* Trust Strip */}
        <div className="mt-10 flex flex-wrap justify-center gap-x-8 gap-y-4" data-id="element-45">
          <div className="flex items-center gap-2" data-id="element-46">
            <ShieldIcon className="w-4 h-4 flex-shrink-0" style={{
            color: 'rgba(255,255,255,0.9)',
            textShadow: '0px 2px 12px rgba(0,0,0,0.6)'
          }} data-id="element-47" />
            <span className="text-base" style={{
            color: 'rgba(255,255,255,0.9)',
            textShadow: '0px 2px 12px rgba(0,0,0,0.6)'
          }} data-id="element-48">
              HIPAA Compliant
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-49">
            <LockIcon className="w-4 h-4 flex-shrink-0" style={{
            color: 'rgba(255,255,255,0.9)',
            textShadow: '0px 2px 12px rgba(0,0,0,0.6)'
          }} data-id="element-50" />
            <span className="text-base" style={{
            color: 'rgba(255,255,255,0.9)',
            textShadow: '0px 2px 12px rgba(0,0,0,0.6)'
          }} data-id="element-51">
              Military-Grade Encryption
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-52">
            <AwardIcon className="w-4 h-4 flex-shrink-0" style={{
            color: 'rgba(255,255,255,0.9)',
            textShadow: '0px 2px 12px rgba(0,0,0,0.6)'
          }} data-id="element-53" />
            <span className="text-base" style={{
            color: 'rgba(255,255,255,0.9)',
            textShadow: '0px 2px 12px rgba(0,0,0,0.6)'
          }} data-id="element-54">
              15+ Years Experience
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-55">
            <GlobeIcon className="w-4 h-4 flex-shrink-0" style={{
            color: 'rgba(255,255,255,0.9)',
            textShadow: '0px 2px 12px rgba(0,0,0,0.6)'
          }} data-id="element-56" />
            <span className="text-base" style={{
            color: 'rgba(255,255,255,0.9)',
            textShadow: '0px 2px 12px rgba(0,0,0,0.6)'
          }} data-id="element-57">
              100+ Languages
            </span>
          </div>
        </div>
      </div>
    </section>;
}